var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E8F4FF",
    stroke: "#008CFF",
    strokeWidth: 1.5,
    transform: "translate(5 5)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 6a7 7 0 017 7v1.734h0H0V13a7 7 0 017-7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 4,
    r: 4
  }))));
}
export default SvgProfile;